module.exports = __webpack_public_path__ + "static/media/etms.73208982.png";